// https://codepen.io/giannisrig/pen/ywBWOV
$(document).ready(function () {
    $(document).click(function () {
        $(".dropdown-menu.show").removeClass("show");
    });

    $("body").on("click", ".lang-trigger-dropdown", function (e) {
        e.stopPropagation();

        $(this).closest(".lang-dropdown-wrapper").find(".dropdown-menu").toggleClass("show");
    });

    $("body").on("click", ".dropdown-item", function (e) {
        e.stopPropagation();

        let $selectedValue = $(this).val();
        //let $icon = $(this).find("svg");
        let $icon = $(this).find("img");
        let $btn = $(this).closest(".lang-dropdown-wrapper").find(".lang-trigger-dropdown");

        $(this).closest(".lang-dropdown-wrapper").find(".dropdown-menu").removeClass("show").attr("data-selected", $selectedValue);

        //$btn.find("svg").remove();
        $btn.find("img").remove();
        $btn.prepend($icon[0].outerHTML);
    });
});
